import React from "react";
import buildInfo from "../../buildInfo.json";

const StatusBar = () => {
  const version = buildInfo.version || "לא ידוע";

  const formatDeploymentDate = (rawDate) => {
    const date = new Date(rawDate);
    if (Number.isNaN(date.getTime())) return "לא ידוע";

    const twoDigits = (value) => String(value).padStart(2, "0");

    const day = twoDigits(date.getDate());
    const month = twoDigits(date.getMonth() + 1);
    const year = date.getFullYear();
    const hours = twoDigits(date.getHours());
    const minutes = twoDigits(date.getMinutes());

    return `${day}/${month}/${year} ${hours}:${minutes}`;
  };

  const deployedAt = buildInfo.deployedAt
    ? formatDeploymentDate(buildInfo.deployedAt)
    : "לא ידוע";

  return (
    <div className="app-status-bar" data-testid="app-status-bar">
      <span>גרסת ממשק: {version}</span>
      <span>תאריך פריסה: {deployedAt}</span>
    </div>
  );
};

export default StatusBar;
